<ng-template cellTemplate let-dataItem="dataItem">
    <fui-actions>
        <ng-container *ngFor="let action of actions | slice:0:4;">
            <wbo-search-action *ngIf="action.isAvailable(dataItem)"
                               (click)="doAction(action, dataItem)"
                               [icon]="action.getIcon(dataItem)"
                               [iconClass]="action.getIconClass(dataItem)"
                               [iconSize]="action.getIconSize(dataItem)"
                               [title]="action.getName(dataItem)"
                               [attr.action-name]="action.getIcon(dataItem)"></wbo-search-action>
        </ng-container>
        <ng-container *ngIf="actions.length > 4">
            // TODO: Add popup functionality if more than 4 actions
            <ng-container>
                <ng-container *ngFor="let action of actions | slice:4;">
                    <li (click)="doAction(action, dataItem)" [attr.action-name]="action.getIcon(dataItem)">
                        <fui-icon [icon]="action.getIcon(dataItem)" [height]="14" [width]="14"></fui-icon>
                        {{action.getName(dataItem) | translate}}
                    </li>
                </ng-container>
            </ng-container>
        </ng-container>
    </fui-actions>
</ng-template>

<ng-template headerTemplate let-dataItem="dataItem">
</ng-template>
